import logger from './logger';

export * from './logger';
export default logger;
